module.exports = __webpack_public_path__ + "static/media/cabddy-bubble.17cbb888.png";